import { instance } from "./api";
import { toast } from "react-toastify";

const url = process.env.REACT_APP_BASE_URL || "/";

async function getIctWorkshopList(page, limit, filter, companyId) {
  const api =
    url +
    `/ict/companies/${companyId}/workshops?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}`;
  return await instance
    .get(api)
    .then((response) => response)
    .catch((error) => error.response);
}

async function getIctWorkshopTaskSettings(companyId, workshopId) {
  const api =
    url + `/ict/companies/${companyId}/workshops/${workshopId}/tasks`;
  return await instance
    .get(api)
    .then((response) => response)
    .catch((error) => error.response);
}

async function getIctWorkshopParticipantList(
  page,
  limit,
  filter,
  status,
  companyId,
  workshopId
) {
  const api =
    url +
    `/ict/companies/${companyId}/workshops/${workshopId}/participants?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&status=${encodeURIComponent(status ?? "")}`;
  return await instance
    .get(api)
    .then((response) => response)
    .catch((error) => error.response);
}

async function getIctWorkshopDetails(companyId, workshopId) {
  const api =
    url + `/ict/companies/${companyId}/workshops/${workshopId}/details`;
  return await instance
    .get(api)
    .then((response) => response)
    .catch((error) => error.response);
}


async function ictupdateWorkshopDetails(companyId, workshopId, updatedDtata) {
  const api =
    url + `/ict/companies/${companyId}/workshops/${workshopId}/edit`;
  return await instance
    .put(api, updatedDtata)
    .then((response) => response)
    .catch((error) => error.response);
}

async function getIctWorkshopTemplate(companyId,workshopId,t) {
  // call the api for get workshopParticipant list Download

  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/holdinginfo-template`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    if (error?.response?.data?.error?.error_code) {
      toast.error(t(error?.response?.data?.error?.error_code), {
        toastId: 3,
      });
    } else {
      toast.error(
        t(error?.response?.data?.error?.details[0]?.errors[0]?.error_code),
        {
          toastId: 3,
        }
      );
    }
  });
}

async function getIctFollowupMailTemplate(companyId,workshopId,t) {
  // call the api for get followup mail template

  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/followups/implementation-guide-template`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    if (error?.response?.data?.error?.error_code) {
      toast.error(t(error?.response?.data?.error?.error_code), {
        toastId: 3,
      });
    } else {
      toast.error(
        t(error?.response?.data?.error?.details[0]?.errors[0]?.error_code),
        {
          toastId: 3,
        }
      );
    }
  });
}

const head={
  responseType: 'blob',
 }
async function getIctWorkshopParticipantDownload(companyId,workshopId) {
  // call the api for get workshopParticipant list Download

  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/participants/download`;
  return await instance
  .get(api,head)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error?.response;
  });
}


async function deleteIctWorkshopParticipant(
  companyId,
  workshopId,
  participant_ids
) {
  // call the api for delete workshop Participants

  const api =
    url + `/ict/companies/${companyId}/workshops/${workshopId}/participants/delete`;
  return await instance
    .delete(api, { data: { participant_ids: participant_ids } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response?.data;
    });
}

async function getIctWorkshopInventoriesList(
  page,
  limit,
  filter,
  status,
  companyId,
  workshopId,
  round
) {
  const api =
    url +
    `/ict/companies/${companyId}/workshops/${workshopId}/inventories?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&round=${round}&status=${encodeURIComponent(status ?? "")}`;
  return await instance
    .get(api)
    .then((response) => response)
    .catch((error) => error.response);
}


async function DownloadIctInventoryResponseList(companyId,workshopId,round, t) {

  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/inventories/responses/download?round=${round}`;

  return await instance
    .get(api, {})
    .then((response) => {
      return response;
    })
    .catch((error) => {
      //show toast message
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      }
    })
  }

async function sendEmailIctInventoryParticipant(
    companyId,
    workshopId,
    participantIds,
    round
  ) {
    
    const api =
      url + `/ict/companies/${companyId}/workshops/${workshopId}/inventories/send-reminder?round=${round}`;
    return await instance
      .post(api,  { participants: participantIds } )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response?.data;
      });
  }

async function updateIctInventoryDetails(companyId, workshopId, data, round) {

    const api =
      url +
      `/ict/companies/${companyId}/workshops/${workshopId}/inventories/delivery-settings?round=${round}`;
    return await instance
      .put(api, data)
      .then((response) => {
        //retun status 1 for success
        return response;
      })
      .catch((error) => {
        //return error
        return error.response?.data;
      });
  }

  // ict workshop evaluation response list
async function getIctWorkshopEvaluationList(
  page,
  limit,
  filter,
  status,
  companyId,
  workshopId
) {
  const api =
    url +
    `/ict/companies/${companyId}/workshops/${workshopId}/evaluation_responses?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&status=${status}`;
  return await instance
    .get(api)
    .then((response) => response)
    .catch((error) => error.response);
}
// update ict workshop evaluation date
async function updateIctWorkshopEvaluation(companyId,workshopId,updatedData) {
  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/evaluation`;
  
  return await instance
    .put(api, updatedData)
    .then((response) => response)
    .catch((error) => error.response?.data);
}

// resend ict workshop evaluation email
async function resendIctWorkshopEvaluationEmail(companyId,workshopId,participantIds) {
  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/send-evaluation-reminder`;
  return await instance
    .post(api, { participants: participantIds })
    .then((response) => response)
    .catch((error) => error.response?.data);
}
// download ict workshop evaluation response list
async function downloadIctEvaluationResponseList(companyId,workshopId) {
  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/responses/download`;
  return await instance
    .get(api)
    .then((response) => response)
    .catch((error) => error.response?.data);
}
//followup response services
async function getIctFollowUpsList(page,limit,filter,companyId,workshopId) {
  // call the api for get workshop followup list
  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/followups?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}

async function addIctFollowUpDetails(companyId,workshopId,data) {
  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/followups/add`;
  return await instance
    .post(api, data)
    .then((response) => response)
    .catch((error) => error.response?.data);
}

async function updateIctFollowUpDetails(companyId, workshopId,followupId, data) {
// call the api for update workshop followup details
  const api =
    url +
    `/ict/companies/${companyId}/workshops/${workshopId}/followups/${followupId}`;

  return await instance
    .put(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function getIctFollowupResponseList(page, limit, filter, status, companyId, workshopId, followupId) {
  // call the api for get workshop followup participant response list

  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/followups/${followupId}/responses?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&status=${status}`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}
// download ict workshop followup response list
async function downloadIctFollowupResponseList(companyId,workshopId,followupId, t) {

  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/followups/${followupId}/responses/download`;

  return await instance
    .get(api, {})
    .then((response) => {
      return response;
    })
    .catch((error) => {
      //show toast message
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      }
    })
  }
async function resendIctFollowupEmail(companyId,workshopId,followupId,participantIds) {
  const api = url + `/ict/companies/${companyId}/workshops/${workshopId}/followups/${followupId}/send-reminder`;
  return await instance
    .post(api, { participants: participantIds })
    .then((response) => response)
    .catch((error) => error.response?.data);
}
export const ictWorkshopService = {
  getIctWorkshopList,
  getIctWorkshopTaskSettings,
  getIctWorkshopDetails,
  ictupdateWorkshopDetails,
  getIctWorkshopTemplate,
  getIctFollowupMailTemplate,
  getIctWorkshopParticipantList,
  getIctWorkshopParticipantDownload,
  deleteIctWorkshopParticipant,
  getIctWorkshopInventoriesList,
  DownloadIctInventoryResponseList,
  sendEmailIctInventoryParticipant,
  updateIctInventoryDetails,
  getIctWorkshopEvaluationList,
  updateIctWorkshopEvaluation,
  downloadIctEvaluationResponseList,
  resendIctWorkshopEvaluationEmail,
  getIctFollowUpsList,
  addIctFollowUpDetails,
  updateIctFollowUpDetails,
  getIctFollowupResponseList,
  downloadIctFollowupResponseList,
  resendIctFollowupEmail,
};
